const ERR_CANCELED = 'ERR_CANCELED';
const ERR_NETWORK = 'ERR_NETWORK';

export default {
    ERR_CANCELED,
    ERR_NETWORK,
};
